/**
 * Large-screen detection hook.
 *
 * Mirrors Tailwind's `lg` breakpoint so components can choose between
 * desktop-only layouts and mobile tab layouts without mounting both.
 *
 * @module use-large-screen
 */

import * as React from 'react';

const LARGE_SCREEN_BREAKPOINT = 1024;

export function useIsLargeScreen() {
  const [isLargeScreen, setIsLargeScreen] = React.useState<boolean>(() => {
    if (globalThis.window !== undefined) {
      return globalThis.window.innerWidth >= LARGE_SCREEN_BREAKPOINT;
    }
    return false;
  });

  React.useEffect(() => {
    const mql = globalThis.window.matchMedia(`(min-width: ${LARGE_SCREEN_BREAKPOINT}px)`);
    const onChange = () => {
      setIsLargeScreen(mql.matches);
    };

    mql.addEventListener('change', onChange);
    setIsLargeScreen(mql.matches);

    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isLargeScreen;
}
